export class BaseEntity {
  id!: string;
}
